import client from "./client";

export const presetsApi = {
  // `opts` carries axios request options that aren't query params -- in
  // practice just `{ signal }`, so the catalogue page can cancel a
  // superseded request with AbortController (see KitsCatalogue.jsx).
  list: (params, opts) => client.get("/api/presets/", { params, ...opts }),
  get: (id) => client.get(`/api/presets/${id}`),
  upload: (formData, onUploadProgress) =>
    client.post("/api/presets/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress,
    }),
  download: (id) =>
    client.get(`/api/presets/${id}/download`, { responseType: "blob" }),
  report: (id) => client.post(`/api/presets/${id}/report`),
  previewUrl: (id) => `${client.defaults.baseURL}/api/presets/${id}/preview.ogg`,
  // Rating is an upsert server-side (PUT covers both "rate" and "re-rate"),
  // so there's one method for both -- `value` is 1-5. Both PUT and DELETE
  // return the fresh `{ rating_avg, rating_count, my_rating }`.
  rate: (id, value) => client.put(`/api/presets/${id}/rating`, { value }),
  removeRating: (id) => client.delete(`/api/presets/${id}/rating`),
  // Favouriting is a plain toggle; both return `{ is_favorited, favorites_count }`.
  favorite: (id) => client.post(`/api/presets/${id}/favorite`),
  unfavorite: (id) => client.delete(`/api/presets/${id}/favorite`),
  // Same params/opts shape as `list` -- the caller's own favourited items,
  // in the same public shape as the catalogue listing.
  listFavorites: (params, opts) => client.get("/api/presets/favorites", { params, ...opts }),
};

export const GENRES = [
  "Trap",
  "Drill",
  "Hip-Hop",
  "R&B",
  "Afrobeat",
  "Reggaeton",
  "Amapiano",
  "Pop",
  "House / EDM",
  "Other",
];
